import api from './axios';

/**
 * RAM / RMC2 house overrides (Rules 75/76).
 *
 * The company's own share of every verified bill. There is no member on the
 * other side of this money to notice a mistake, so releasing it takes two
 * different administrators — one files the request, a second approves it. The
 * server enforces that on the persisted `requested_by`; the SPA only reflects it.
 */
export const getOverrideLedger = (params = {}) => api.get('/v1/overrides/ledger', { params });

export const listOverrideReleases = (params = {}) =>
  api.get('/v1/overrides/release-requests', { params });

/**
 * Files a release for everything currently Available on one house account.
 * The amount is NOT sent — the server sums the rows, so a caller cannot name
 * a figure the ledger does not support.
 */
export const requestOverrideRelease = (payload) =>
  api.post('/v1/overrides/release-requests', payload, {
    headers: { 'Idempotency-Key': (crypto?.randomUUID?.() ?? `${Date.now()}-${Math.random()}`) },
  });

/** The second signature. Refused if it is the same admin who filed it. */
export const approveOverrideRelease = (overrideId, payload) =>
  api.post(`/v1/overrides/release-requests/${overrideId}/approve`, payload, {
    headers: { 'Idempotency-Key': (crypto?.randomUUID?.() ?? `${Date.now()}-${Math.random()}`) },
  });
